import { create } from 'zustand';
import { IFeedbackTag } from '../../../types';

export type FeedbackTagStoreTags = Record<string, IFeedbackTag[]>;

export type FeedbackTagStoreState = {
  /**
   * Represents the available tags for feedback in the FeedbackTagStore class.
   */
  groups: FeedbackTagStoreTags;

  /**
   * Sets the tags for a given survey.
   */
  setTags: (groupId: string, tags: IFeedbackTag[]) => void;

  /**
   * Removes a feedback tag from a survey.
   */
  remove: (groupId: string, tag: IFeedbackTag) => void;

  /**
   * Updates the feedback tag for a given survey.
   */
  update: (groupId: string, tag: IFeedbackTag) => void;

  /**
   * Adds a tag to a survey.
   */
  addTag: (groupId: string, tag: IFeedbackTag) => void;
};

export const useFeedbackTagStore = create<FeedbackTagStoreState>(set => ({
  groups: {},
  setTags: (groupId, tags) =>
    set(state => ({
      ...state,
      groups: {
        ...state.groups,
        [groupId]: tags,
      },
    })),

  update: (groupId, tag) =>
    set(state => {
      const tags = state.groups[groupId];

      return {
        ...state,
        groups: {
          ...state.groups,
          [groupId]: [...tags].map(t => (t.id === tag.id ? tag : t)),
        },
      };
    }),

  remove: (groupId, tag) =>
    set(state => {
      return {
        ...state,
        groups: {
          ...state.groups,
          [groupId]: [...state.groups[groupId]].filter(t => t.id !== tag.id),
        },
      };
    }),

  addTag: (groupId, tag) =>
    set(state => {
      const tags = state.groups[groupId] ?? [];

      return {
        ...state,
        groups: {
          ...state.groups,
          [groupId]: [...tags, tag],
        },
      };
    }),
}));
